// extracted by mini-css-extract-plugin
export default {"root":"style_root__HtxSe","list":"style_list__UAAgL"};